import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { i18nGetCurrentLanguage } from "../Infra/i18next";
import { NOT_LOADED } from "../Infra/RemoteData";
import { LoadingPlaceholder } from "./LoadingPlaceholder";
import { PageWithFixedHeaderAndFooterContent, PatientConsentParent } from "./PatientConsentManagerShared.styles";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
import { ScreenshotReadinessDetector } from "./ScreenshotReadinessDetector";
import { useViewModel } from "./useViewModel";
import { buildGetCustomizedText, RequestDetailsView } from "./RequestDetailsView";
export const PatientConsentRequestDetailsView = observer((props) => {
    const model = useViewModel(PatientConsentViewModel, props.container);
    if (model.studyInfo === NOT_LOADED)
        return _jsx(LoadingPlaceholder, { w: 10, h: 60 });
    if (!model.isInConsentFlow)
        return null;
    const study = model.studyInfo;
    const currentLanguage = i18nGetCurrentLanguage();
    const content = {
        isIAS: model.isIAS,
        isAIFlow: model.isAIFlow,
        isScreenshotMode: model.isScreenshotMode,
        patientFriendlyTitle: model.patientFriendlyTitle,
        aiToolName: model.aiToolName,
        study,
        getCustomizedText: buildGetCustomizedText(study, currentLanguage),
        getSectionImages: model.getSectionImages,
    };
    return (_jsx(ScreenshotReadinessDetector, { isScreenshotMode: model.isScreenshotMode, children: _jsx(PageWithFixedHeaderAndFooterContent, { isHeaderAndFooterFixed: model.isHeaderAndFooterFixed, children: _jsx(PatientConsentParent, { children: _jsx(RequestDetailsView, { container: props.container, hideTitle: props.hideTitle, content: content, onViewImage: props.onViewImage }) }) }) }));
});
